import React, { memo, useState } from "react";
import styled from "styled-components";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import { RoundedIcon } from "../rounded-icon/rounded-icon";
import {
  setBackgroundColor,
  setBackgroundColorIcon,
  setTextColor,
  setTextColorIcon,
} from "../../helpers/set-color";
import { moduleSettings } from "../../stores/module-settings.store";

interface IProps {
  text: string;
  status?: string;
  collapsable?: boolean;
}

interface IStyled {
  backgroundColor?: string;
  textColor?: string;
  collapsed?: boolean;
}

const InformationWrapper = styled.div<IStyled>`
  position: relative;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
  text-align: center;
  border-radius: 5px;
  padding: 12px 22px;
  margin-bottom: 32px;

  .showMoreOrLess {
    position: absolute;
    right: 8px;
    bottom: 8px;
  }
`;

const InformationStyle = styled.div<IStyled>`
  position: relative;
  width: 100%;
  height: ${(props) => (props.collapsed ? "60px" : "100%")};
  line-height: ${(props) => (props.collapsed ? "20px" : "inherit")};
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  white-space: normal;
  word-wrap: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => (props.collapsed ? 3 : "")};
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
`;

const Information = (props: IProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const mappedText = props.text.split("\r\n").join("</br>");
  const backgroundColor = setBackgroundColor(props.status);
  const textColor = setTextColor(props.status);
  const backgroundColorIcon = setBackgroundColorIcon(props.status);
  const textColorIcon = setTextColorIcon(props.status);
  const isRoPlt = moduleSettings.isRoPlt;
  const notDisplayDefaultIcon =
    isRoPlt && (props.status === "" || props.status === undefined);

  const handleClick = (event: any) => {
    setIsCollapsed(!isCollapsed);
  };

  const icon = isCollapsed ? (
    <ExpandMore
      className="showMoreOrLess"
      onClick={handleClick}
      data-test="collapsable-icon"
    />
  ) : (
    <ExpandLess
      className="showMoreOrLess"
      onClick={handleClick}
      data-test="collapsable-icon"
    />
  );

  return (
    <InformationWrapper backgroundColor={backgroundColor} textColor={textColor}>
      {!notDisplayDefaultIcon && (
        <RoundedIcon
          icon={props.status || ""}
          backgroundColor={backgroundColorIcon}
          textColor={textColorIcon}
          size="large"
          border={props.status === "waiting" ? false : true}
          position="left"
        />
      )}
      <InformationStyle
        dangerouslySetInnerHTML={{ __html: mappedText }}
        collapsed={isCollapsed}
        data-test="text-information"
      />
      {props.collapsable && icon}
    </InformationWrapper>
  );
};
export const InformationText = memo(Information);
